import { newNode } from "./model";
import { nodeType } from "./scenario";
import type { CampaignTemplate, MarketingStep } from "./types";

/** Только создание из каталога. Сохранённые определения и копии кампаний сюда не попадают. */
export function withStudioScenario(
  template: CampaignTemplate,
): CampaignTemplate {
  const source = template.defaultSteps;
  if (!source?.length || source.some((s) => nodeType(s) !== "message"))
    return template;
  const push = source.find((s) => s.channel === "push");
  const email = source.find((s) => s.channel === "email");
  const sms = source.find((s) => s.channel === "sms");
  if (!push || !email || !sms || source.length !== 3) return template;
  const node = (
    id: string,
    type: MarketingStep["type"],
    label: string,
    x: number,
    y: number,
  ): MarketingStep => ({
    ...newNode(type!),
    id,
    label,
    canvasX: x,
    canvasY: y,
  });
  const condition = (
    id: string,
    label: string,
    field: string,
    yes: string,
    no: string,
    x: number,
    y: number,
  ): MarketingStep => ({
    ...node(id, "segmentSplit", label, x, y),
    split: {
      condition: {
        kind: "group",
        op: "all",
        children: [
          {
            kind: "rule",
            field,
            op: field === "ordersInPeriod" ? "gte" : "eq",
            value: field === "ordersInPeriod" ? 1 : true,
            ...(field === "ordersInPeriod" ? { periodMinutes: 1440 } : {}),
          },
        ],
      },
      trueStepId: yes,
      falseStepId: no,
    },
  });
  const action = (
    step: MarketingStep,
    id: string,
    next: string,
    x: number,
    y: number,
  ): MarketingStep => ({
    ...structuredClone(step),
    id,
    type: "message",
    label: "",
    nextStepId: next,
    waitHours: 0,
    fallback: "always",
    onUnavailable: "next",
    unreadFallback: undefined,
    promoMode: "none",
    promoCode: "",
    promoPoolId: "",
    canvasX: x,
    canvasY: y,
  });
  return {
    ...template,
    defaultSteps: [
      condition(
        "push-ready",
        "Доступен Push",
        "pushReady",
        "push",
        "email-ready",
        260,
        320,
      ),
      action(push, "push", "wait-open", 520, 120),
      {
        ...node("wait-open", "delay", "Подождать открытия", 780, 120),
        waitHours: 0,
        delayMinutes: 15,
        nextStepId: "opened",
      },
      condition(
        "opened",
        "Открыл сообщение",
        "pushOpened",
        "finish",
        "ordered",
        1040,
        120,
      ),
      condition(
        "email-ready",
        "Доступен Email",
        "emailReady",
        "email",
        "ordered",
        520,
        580,
      ),
      action(email, "email", "wait-order", 780, 460),
      {
        ...node("wait-order", "delay", "День на заказ", 1040, 340),
        waitHours: 0,
        delayMinutes: 1440,
        nextStepId: "ordered",
      },
      condition(
        "ordered",
        "Есть заказ за 24 часа",
        "ordersInPeriod",
        "finish",
        "sms",
        1300,
        420,
      ),
      action(sms, "sms", "finish", 1560, 460),
      node("finish", "exit", "", 1820, 200),
    ],
  };
}
